
      import { isMobile } from './src/utils/device.js';

      // Service Worker (PWA)
      // Il SW viene registrato solo in produzione: in sviluppo locale (Vite)
      // intercetterebbe le richieste CSS/JS trasformate da Vite causando
      // errori di MIME type e invalidando l'HMR
      const isDev = location.hostname === 'localhost'    ||
                    location.hostname === '127.0.0.1'    ||
                    location.hostname.startsWith('192.168.');
      if ('serviceWorker' in navigator && !isDev) {
        navigator.serviceWorker.register('/sw.js').catch((err) => {
          console.warn('[PWA] Service worker non registrato:', err);
        });
      } else if ('serviceWorker' in navigator && isDev) {
        // In sviluppo: rimuove qualsiasi SW rimasto da sessioni precedenti
        navigator.serviceWorker.getRegistrations().then((regs) => {
          regs.forEach(r => r.unregister());
        });
      }

      // Logica orientamento / fullscreen / installazione
      (function () {
        const overlay       = document.getElementById('rotate-overlay');
        const btnFS         = document.getElementById('btn-fullscreen');
        const btnInstall    = document.getElementById('btn-install');
        const iosHint       = document.getElementById('ios-install-hint');
        const icon          = document.getElementById('rotate-icon');
        const appIcon       = document.getElementById('app-icon');
        const title         = document.getElementById('rotate-title');
        const sub           = document.getElementById('rotate-sub');

        if (!overlay) return;

        // Rileva se l'applicazione è dentro un iframe
        const isInIframe = window !== window.top;

        // Capacità del browser
        const isAndroid = /android/i.test(navigator.userAgent);
        const canFullscreen = !!(
          document.documentElement.requestFullscreen ||
          document.documentElement.webkitRequestFullscreen
        );
        const canLockOrientation = !!(
          screen.orientation && typeof screen.orientation.lock === 'function'
        );
        // iOS: ha touch ma non ha beforeinstallprompt né requestFullscreen
        const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent) ||
                      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
        // App già installata come PWA (display-mode: standalone o fullscreen)
        const isPWA = window.matchMedia('(display-mode: standalone)').matches ||
                      window.matchMedia('(display-mode: fullscreen)').matches ||
                      window.navigator.standalone === true;

        // Intercetta beforeinstallprompt (Chrome Android, solo top-level — non scatta in iframe)
        // Chiamare preventDefault() qui impedisce il banner automatico di Chrome
        // Il prompt verrà mostrato solo quando l'utente preme "Installa l'app"
        let _deferredInstallPrompt = null;
        window.addEventListener('beforeinstallprompt', (e) => {
          e.preventDefault();
          _deferredInstallPrompt = e;
          // Mostra il pulsante solo ora che il prompt è disponibile
          btnInstall.style.display = 'inline-flex';
        });

        // Nasconde il pulsante installa dopo l'installazione avvenuta
        window.addEventListener('appinstalled', () => {
          _deferredInstallPrompt = null;
          btnInstall.style.display = 'none';
        });

        // In iframe Android beforeinstallprompt non scatta mai: mostra subito
        // il bottone "Installa l'app". Il click aprirà l'app in una nuova tab
        // dove l'utente potrà installarla normalmente
        if (isInIframe && isAndroid && !isIOS) {
          btnInstall.style.display = 'inline-flex';
        }

        // Android Chrome normale (non iframe, non PWA) in incognito:
        // beforeinstallprompt non scatta → mostro il bottone con un fallback testuale
        if (!isInIframe && isAndroid && !isPWA) {
          btnInstall.style.display = 'inline-flex';
        }

        // Helper
        function isPortrait() {
          if (screen.orientation && screen.orientation.type) {
            return screen.orientation.type.startsWith('portrait');
          }
          return screen.height > screen.width;
        }

        function isFullscreen() {
          return !!(document.fullscreenElement || document.webkitFullscreenElement);
        }

        // Ripristina l'overlay nella variante "ruota dispositivo" (icona ⟳ rotante)
        // Usata quando il fullscreen fallisce
        function showRotateOverlay() {
          appIcon.style.display = 'none';
          icon.style.display    = '';
          icon.textContent      = '⟳';
          icon.classList.add('rotate-icon--spin');
          title.textContent     = 'Ruota il dispositivo';
          sub.textContent       = "L'applicazione funziona solo in modalità orizzontale.";
          btnFS.style.display   = 'none';
        }

        // Aggiorna overlay
        function updateOverlay() {
          const mobile     = isMobile();
          const portrait   = isPortrait();
          const fullscreen = isFullscreen();

          // Desktop, PWA già installata, fullscreen attivo: nascondi
          // Su Android (isAndroid && !isIOS) la sola rotazione in landscape
          // non basta: l'overlay resta finché l'utente non attiva il fullscreen.
          // Su iOS e browser fallback invece il landscape da solo è sufficiente.
          const landscapeDismisses = isIOS || !isAndroid;
          if (!mobile || isPWA || fullscreen || (!portrait && landscapeDismisses)) {
            overlay.style.display = 'none';
            return;
          }

          // Portrait nel browser mobile: mostra overlay
          overlay.style.display = 'flex';

          if (isIOS) {
            // iOS Safari: solo rotazione + hint installazione manuale
            appIcon.style.display    = 'none';
            icon.style.display       = '';
            icon.textContent         = '⟳';
            icon.classList.add('rotate-icon--spin');
            title.textContent        = 'Ruota il dispositivo';
            sub.textContent          = 'L\'applicazione funziona solo in modalità orizzontale.';
            btnFS.style.display      = 'none';
            btnInstall.style.display = 'none';
            iosHint.style.display    = 'block';
          } else if (isAndroid) {
            // Android Chrome: offre schermo intero + installa se disponibile
            // (il bottone installa è già visibile se beforeinstallprompt è scattato
            // oppure se l'applicazione è in iframe — impostato alla rilevazione iniziale)
            appIcon.style.display = 'block';
            icon.style.display    = 'none';
            icon.classList.remove('rotate-icon--spin');
            title.textContent     = 'Scegli come usare l\'app';
            sub.textContent       = 'Attiva lo schermo intero oppure installa l\'app per la migliore esperienza.';
            btnFS.style.display   = canFullscreen ? 'inline-flex' : 'none';
            iosHint.style.display = 'none';
          } else {
            // Altro browser senza fullscreen API
            appIcon.style.display    = 'none';
            icon.style.display       = '';
            icon.textContent         = '⟳';
            icon.classList.add('rotate-icon--spin');
            title.textContent        = 'Ruota il dispositivo';
            sub.textContent          = 'L\'applicazione funziona solo in modalità orizzontale.';
            btnFS.style.display      = 'none';
            iosHint.style.display    = 'none';
          }
        }

        // Pulsante Schermo intero
        btnFS.addEventListener('click', async () => {
          try {
            const el = document.documentElement;
            if (el.requestFullscreen)            await el.requestFullscreen();
            else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();

            if (canLockOrientation) {
              await screen.orientation.lock('landscape').catch(() => {});
            }
            updateOverlay();
          } catch {
            // Fullscreen rifiutato: ripristina la UI con la freccia rotante visibile
            showRotateOverlay();
          }
        });

        // Pulsante Installa l'app
        btnInstall.addEventListener('click', async () => {
          if (_deferredInstallPrompt) {
            // Contesto top-level: usa il prompt nativo del browser
            _deferredInstallPrompt.prompt();
            const { outcome } = await _deferredInstallPrompt.userChoice;
            if (outcome === 'accepted') {
              _deferredInstallPrompt   = null;
              btnInstall.style.display = 'none';
            }
          } else if (isInIframe) {
            // Contesto iframe: apri l'app in una nuova tab dove
            // beforeinstallprompt può scattare e l'installazione è possibile
            try { window.top.postMessage({ type: 'homecraft-open-standalone' }, '*'); } catch (_) {}
            window.open(window.location.href, '_blank');
          } else {
            // Incognito o prompt non disponibile: istruzioni manuali
            alert('Per installare l\'app, apri HomeCraft in una scheda normale di Chrome (non in incognito), poi tocca il menu ⋮ → "Aggiungi a schermata Home".');
          }
        });

        // Listener
        if (screen.orientation) screen.orientation.addEventListener('change', updateOverlay);
        window.addEventListener('orientationchange', updateOverlay);
        window.addEventListener('resize', updateOverlay);
        document.addEventListener('fullscreenchange', updateOverlay);
        document.addEventListener('webkitfullscreenchange', updateOverlay);

        updateOverlay();
      })();
    